
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipIec as ObiOwnShipIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-iec.js';
 
 
 

 
 export const ObiOwnShipIec = createComponent({
   react: React,
   tagName: 'obi-own-ship-iec',
   elementClass: ObiOwnShipIecElement,
   events: {
     
   }
  });
 
 